import UploadModel from '@/models/UploadModel.js'
import { action, computed, observable, runInAction } from 'mobx'

export default class UploadsStore {
  rootStore = null

  @observable accessor #uploads = observable.map()

  constructor(rootStore) {
    this.rootStore = rootStore
    this.rootStore.registerDeconstructor(this.#_deconstructor)
  }

  #_deconstructor = async () => {
    await this.reset()
  }

  reset = async () => {
    await Promise.all(this.#uploadsArray.map(x => x.abort()))

    runInAction(() => {
      this.#uploads.clear()
    })
  }

  @computed
  get isUploading() {
    return this.#uploadsArray.some(x => x.isUploading)
  }

  @computed
  get #uploadsArray() {
    return Array.from(this.#uploads.values())
  }

  getUpload = id => this.#uploads.get(id)

  @action
  addUpload = (id, file) => {
    const existing = this.#uploads.get(id)
    if (existing) return existing

    if (!file.type?.startsWith('video/')) return null

    const upload = new UploadModel(this.rootStore, file)
    this.#uploads.set(id, upload)

    upload.start()

    return upload
  }

  removeUpload = async (id, forceDelete = false) => {
    this.#uploads.get(id)?.reset(forceDelete)

    runInAction(() => {
      this.#uploads.delete(id)
    })
  }
}
